<template>
  <div :style="style">
    <div
      class="annot8-hl"
      :class="classH(h)"
      :data-id="h.id"
      :style="styleH(h)"
      v-for="(h, idx) in state.highlights"
      :key="idx"
    ></div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },

  props: {
    state: Object,
    highlights: Array
  },

  computed: {
    style() {
      return {
        position: "absolute",
        top: this.state.canvas.top + "px",
        left: this.state.canvas.left + "px",
        width: this.state.canvas.width + "px",
        height: this.state.canvas.height + "px",
        "z-index": 0
      };
    }
  },

  methods: {
    styleH(h) {
      return {
        position: "absolute",
        top: h.y + "px !important",
        left: h.x + "px !important",
        width: h.width + "px !important",
        height: h.height + "px !important"
      };
    },

    classH(h) {
      var res = ["annot8-hl-" + h.tag];
      if (h.id === this.state.focus) {
        res.push("annot8-active");
      }
      return res;
    }
  }
};
</script>
